interface Size {
  width: number;
  height: number;
}

interface Position {
  left: number;
  top: number;
}

const GAP = 10;
const MARGIN = 8;

/**
 * Abre à esquerda e vira para a direita quando não couber — mesma regra de flip de
 * `getTooltipPosition` (components/Tooltip), mas medindo o cartão real em vez de estimar
 * a altura por contagem de linhas.
 *
 * O eixo horizontal usa a lista inteira, não o botão: ancorar no botão põe o cartão por cima
 * das outras opções, que são justamente o que se quer comparar. O vertical usa o botão, para
 * o cartão nascer na altura da linha consultada.
 */
export const getPreviewPosition = (list: DOMRect, anchor: DOMRect, card: Size): Position => {
  let left = list.left - GAP - card.width;

  if (left < MARGIN) {
    const toTheRight = list.right + GAP;
    left =
      toTheRight + card.width > window.innerWidth - MARGIN
        ? Math.max(MARGIN, window.innerWidth - MARGIN - card.width)
        : toTheRight;
  }

  let top = anchor.top;

  if (top + card.height > window.innerHeight - MARGIN) {
    top = window.innerHeight - MARGIN - card.height;
  }

  return { left, top: Math.max(MARGIN, top) };
};
